<template>
  <div class="bank-detail-container">
    <Breadcrumb
      v-if="loaded"
      :company="company_uid"
      :project="bankData.project_uid"
      :customer="apiMode === 'customer' ? bankData.enduserId : ''"
      :bankaccount="bankData.bankholderId"
    />

    <el-card class="box-card" v-if="loaded">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-money"></i> Bank Account Info</span>
        <span>
          <el-button
            v-if="superRole"
            icon="el-icon-edit"
            style="float: right; padding: 0 10px"
            type="text"
            @click="showDialogEdit()"
            >Edit</el-button
          >
        </span>
        <span v-if="complianceClose || bankData.status != 'closed'">
          
          <el-button
            v-if="flag_flowfund && apiMode === 'customer'"
            icon="el-icon-money"
            style="float: right; padding: 0 10px"
            type="text"
            @click="showDepositTopup()"
            >Deposit</el-button
          >
          <el-button
            v-if="flag_flowfund && apiMode === 'project'"
            icon="el-icon-money"
            style="float: right; padding: 0 10px"
            type="text"
            @click="showTrasfer()"
            >Transfer</el-button
          >
          <el-button
            v-if="flag_flowfund && apiMode === 'project'"
            icon="el-icon-shopping-cart-1"
            style="float: right; padding: 0 10px"
            type="text"
            @click="showPayment()"
            >Payment</el-button
          >
          <el-button
            v-if="apiMode === 'customer'"
            icon="el-icon-present"
            style="float: right; padding: 0 10px"
            type="text"
            @click="showPurchase()"
            >Purchase</el-button
          >
        </span>
      </div>
      <div>
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <div
              :class="
                `balance-currency currency-color-${bankData.currency.toLowerCase()}`
              "
            >
              {{ bankData.currency.toUpperCase() }}
            </div>

            <el-col
              :xs="24"
              :sm="24"
              :md="apiMode === 'customer' ? 12 : 24"
              :lg="apiMode === 'customer' ? 12 : 24"
            >
              <div class="balance-number">
                {{
                  `${bankData.currency.toUpperCase()} ${bankData.balanceFormat}`
                }}
              </div>
              <div class="balance-text">
                Balance
                <el-button
                  v-if="
                    userCompliancework &&
                      Number(bankData.balanceFormat) != 0 &&
                      apiMode === 'customer'
                  "
                  type="primary"
                  plain
                  size="mini"
                  @click="showClearBalance"
                  >Clear Balance</el-button
                >
              </div>
            </el-col>

            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              v-if="apiMode === 'customer'"
            >
              <div class="balance-number">
                {{ currencyFormat(creditData.balance) }}
              </div>
              <div class="balance-text">Monthly fee Credit Balance</div>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="24"
              :lg="24"
              v-if="apiMode === 'customer' && editRole"
            >
              <contract-balance :currency="bankData.currency" :customerUID="bankData.enduserId" />
            </el-col>

            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              v-if="apiMode === 'customer' && debtSum"
            >
              <div class="balance-number text-danger">{{ debtSum }}</div>
              <div class="balance-text text-danger">Debt</div>
            </el-col>

            <el-col :xs="24">
              <PlusCard v-if="cardData" :cardData="cardData" />
            </el-col>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form
              class="bank-info"
              label-width="250px"
              size="small"
              :label-position="device === 'mobile' ? 'top' : 'right'"
            >
              <el-form-item label="Create By">
                {{ bankData.createUser }}
              </el-form-item>
              <el-form-item label="Name">
                {{ bankData.name }}
              </el-form-item>
              <el-form-item label="Member Code">
                {{ bankData.member_code }}
              </el-form-item>
              <el-form-item label="Vender" v-if="superRole">
                {{ venderType[bankData.vender_type] }}
              </el-form-item>
              <el-form-item label="Bankholder ID">
                {{ bankData.bankholderId }}
              </el-form-item>
              <el-form-item label="Ledger UUID">
                {{ bankData.ledgerId }}
              </el-form-item>
              <el-form-item label="Currency">
                {{ bankData.currency.toUpperCase() }}
              </el-form-item>

              <div v-if="bankData.currency.toUpperCase() === 'GBP'">
                <el-form-item label="Account Number">
                  {{ bankData.accountnumber || "N/A" }}
                </el-form-item>
                <el-form-item label="Sortcode">
                  {{ bankData.sortcode || "N/A" }}
                </el-form-item>
              </div>
              <div v-if="bankData.currency.toUpperCase() === 'EUR'">
                <el-form-item label="SEPA IBAN">
                  {{ bankData.iban || "N/A" }}
                </el-form-item>
                <el-form-item label="BIC">
                  {{ bankData.bic || "N/A" }}
                </el-form-item>
                <el-form-item label="Reference" v-if="bankData.vender_type === 'ifx'">
                  {{ bankData.bank_ref || "N/A" }}
                </el-form-item>
              </div>
              <div v-if="bankData.vender_type === 'lloyds' || bankData.vender_type === 'ifxv2'">
                <el-form-item label="International IBAN">
                  {{ bankData.iban || "N/A" }}
                </el-form-item>
                <el-form-item label="International BIC">
                  {{ bankData.bic || "N/A" }}
                </el-form-item>
              </div>
              <div v-else>
                <el-form-item label="International IBAN">
                  {{ bankData.international.account_iban || "N/A" }}
                </el-form-item>
                <el-form-item label="International BIC">
                  {{ bankData.international.sortcode_bic || "N/A" }}
                </el-form-item>
                <el-form-item label="Correspondent Bank SWIFT">
                  {{ bankData.international.swiftcode || "N/A" }}
                </el-form-item>
              </div>

              <el-form-item label="IBAN Status">
                {{ bankData.ibanstatus }}
              </el-form-item>
              <el-form-item label="Purpose">
                {{ bankData.purpose }}
              </el-form-item>
              <el-form-item label="Type">
                {{ bankData.type }}
              </el-form-item>
              <el-form-item label="Status">
                {{ bankData.status }}
              </el-form-item>

              <el-form-item label="Create Date">
                {{ bankData.createdDate }}
              </el-form-item>
              <el-form-item label="Update Date">
                {{ bankData.updatedDate }}
              </el-form-item>
              <el-form-item label="Closed Date">
                {{ bankData.deletedDate ? bankData.deletedDate : "N/A" }}
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <FormDepositTopup ref="formDepositTopup" v-on:submited="submited" />
    </el-card>

    <el-tabs v-if="loaded" v-model="tabActive">
      <el-tab-pane label="Statement" name="statement">
        <StatementReport :bankholderID="bankholderID" :apiMode="apiMode" :vender="bankData.vender_type" />
      </el-tab-pane>
      <el-tab-pane
        label="Monthly fee Credit"
        v-if="apiMode === 'customer'"
        name="fee"
      >
        <CreditReport :bankholderID="bankholderID" v-on:submited="submited" />
      </el-tab-pane>
      <el-tab-pane label="Monthly Contract" v-if="apiMode === 'customer' && editRole" name="monthly-contract">
        <contract-report type="monthly" :customerUID="bankData.enduserId" />
      </el-tab-pane>
      <el-tab-pane label="Compliance Contract" v-if="apiMode === 'customer' && editRole" name="compliance-contract">
        <contract-report type="compliance" :customerUID="bankData.enduserId" />
      </el-tab-pane>
      <el-tab-pane label="Card" name="card">
        <CardBank :bankholderID="bankholderID" v-on:rendered="getCardPicture" />
      </el-tab-pane>
      <el-tab-pane
        label="Compliance"
        v-if="apiMode === 'customer'"
        name="compliance"
      >
        <Compliance :bankholderID="bankholderID" />
      </el-tab-pane>
      <el-tab-pane label="Debt" v-if="apiMode === 'customer'" name="debt">
        <DebtLedger :ledgerID="bankData.ledgerId" />
      </el-tab-pane>
      <el-tab-pane
        label="Monthly Fee Log"
        v-if="apiMode === 'customer'"
        name="monthly-fee-log"
      >
        <MonthlyFeeLog :bankholderID="bankholderID" />
      </el-tab-pane>

      <el-tab-pane
        label="Pending Statement"
        v-if="apiMode === 'customer' && superRole"
        name="pending-statement"
      >
        <StatementPending :ledgerID="bankData.ledgerId" />
      </el-tab-pane>
    </el-tabs>

    <FormTransfer ref="formTransfer" v-on:submited="submited" />
    <FormPurchase ref="formPurchase" v-on:submited="submited" />

    <FormBankAccount
      ref="formBankAccount"
      :projectUID="user_project"
      :customerUID="company_uid"
      :apiMode="apiMode"
      v-on:submited="submited"
    />

    <FormPayment ref="formPayment" v-on:submited="submited" />
    <FormClearBalance ref="formClearBalance" v-on:submited="submited" />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import PlusCard from "@/components/PlusCard";
import { mapGetters } from "vuex";
import { getBankAccountBy } from "@/api/bank-account";
import { getCreditBalance } from "@/api/monthlyfeecredits";
import { getCustomerBy } from "@/api/customer";
import { getProjectBy } from "@/api/project";
import { getDebtLedgerSummary } from "@/api/debt";
import FormDepositTopup from "@/views/bank-account/components/form-deposit-topup";
import StatementReport from "@/views/report/components/bank-statement-report";
import StatementPending from "@/views/report/components/bank-statement-pending";
import CreditReport from "@/views/report/components/bank-account-credit-report";
import Compliance from "@/views/report/components/bank-account-compliance-report";
import FormTransfer from "@/views/bank-account/components/form-transfer";
import FormPayment from "@/views/bank-account/components/bank-payment";
import { currencyFormat } from "@/utils";
import FormBankAccount from "@/views/bank-account/components/form-bankaccount";
import CardBank from "@/views/card/components/card-bank-manager";
import DebtLedger from "@/views/bank-account/components/debt-ledger";
import FormPurchase from "@/views/bank-account/components/form-purchase";
import FormClearBalance from "@/views/bank-account/components/form-clearbalance";
import ContractReport from "@/views/bank-account/components/contract-report";
import ContractBalance from '@/views/bank-account/components/contract-balance.vue';
import MonthlyFeeLog from "@/views/bank-account/components/monthly-fee-log.vue";

export default {
  components: {
    FormDepositTopup,
    Breadcrumb,
    StatementReport,
    FormTransfer,
    CreditReport,
    FormBankAccount,
    CardBank,
    FormPayment,
    Compliance,
    PlusCard,
    DebtLedger,
    StatementPending,
    FormPurchase,
    FormClearBalance,
    ContractReport,
    ContractBalance,
    MonthlyFeeLog,
  },
  computed: {
    ...mapGetters([
      "company_name",
      "company_uid",
      "user_project",
      "flag_flowfund",
    ]),
    device() {
      return this.$store.state.app.device;
    },
    editRole() {
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    },
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
    userCompliancework(){
      return this.$store.state.user.user_compliancework
    },
    complianceClose() {
      return Object.keys(this.bankData).length > 0
        ? this.bankData.createUser.includes("-closedbycompliance")
        : false;
    },
  },
  data() {
    return {
      loaded: false,
      apiMode: this.$route.params.api_mode,
      bankholderID: this.$route.params.bankholder_id,
      bankData: {},
      ledger: {},
      projectInfo: {},
      customerInfo: {},
      creditData: {},
      cardData: null,
      debtSum: "",
      tabActive: this.$route.query.tab || "statement",
      venderType: {
        "railsbank": "Railsbank",
        "internal": "Internal",
        "abwallet": "ABWallet",
        "ifx": "Barclays",
        "lloyds": "Lloyds Bank",
        "ifxv2": "Barclays v2",
      }
    };
  },
  methods: {
    getBankAccountData() {
      this.loaded = false;
      const loading = this.$notifyloading("Loading data...");
      getBankAccountBy(this.bankholderID).then(({ result, data }) => {
        if (result && data) {
          this.bankData = data;
          this.loaded = true;
          this.getCreditBalanceData();
          this.getLedgerSummary(this.bankData.ledgerId);
          loading.close();
        }
      });
    },
    getProjectInfo(project_uid, customer_uid) {
      getProjectBy(project_uid).then(({ result, data }) => {
        if (result) {
          this.projectInfo = data;
          this.getCustomerInfo(customer_uid);
        }
      });
    },
    getCustomerInfo(customer_uid) {
      getCustomerBy(customer_uid).then(({ result, data }) => {
        if (result && data) {
          this.customerInfo = data;
          this.loaded = true;
        }
      });
    },
    getCreditBalanceData() {
      getCreditBalance(this.bankData.bankholderId).then(({ result, data }) => {
        if (result) {
          this.creditData = data;
        }
      });
    },
    getLedgerSummary(ledger_id) {
      getDebtLedgerSummary(ledger_id).then(({ result, data }) => {
        if (result) {
          this.debtSum = data ? data.amountFormat : "";
        }
      });
    },
    showDepositTopup() {
      this.$refs.formDepositTopup.showDepositTopup(
        this.bankData.bankholderId,
        this.bankData.currency
      );
    },
    showTrasfer() {
      this.$refs.formTransfer.showDialogTransfer(
        this.bankData.bankholderId,
        this.bankData.currency,
        true
      );
    },
    showDialogEdit() {
      this.$refs.formBankAccount.showDialog(
        "edit", 
        this.bankData.bankholderId
      );
    },
    showPayment() {
      this.$refs.formPayment.showDialogPayment(
        this.bankData.bankholderId,
        this.bankData.currency,
        this.user_project
      );
    },
    submited() {
      setTimeout(() => {
        this.getBankAccountData();
      }, 2000);
    },

    getCardPicture(data) {
      if (data) {
        this.cardData = data;
      }
    },

    currencyFormat(num = 0, currency) {
      return currencyFormat(num, currency);
    },
    showPurchase() {
      this.$refs.formPurchase.show(
        this.bankData.bankholderId,
        this.bankData.currency
      );
    },
    showClearBalance() {
      this.$refs.formClearBalance.show(
        this.bankData.bankholderId,
        this.bankData.currency
      );
    },
  },
  created() {
    this.getBankAccountData();
  },
};
</script>

<style lang="scss">
.bank-detail-container {
  form.bank-info {
    .el-form-item--small.el-form-item {
      margin-bottom: 0px;
    }
  }
  .balance-currency,
  .balance-number,
  .balance-text {
    text-align: center;
  }

  .balance-currency {
    font-size: 5rem;
    margin-bottom: 10px;
  }
  .balance-number {
    font-size: 1.5rem;
    margin-bottom: 10px;
  }

  .balance-text {
    font-size: 1.2rem;
    margin-bottom: 50px;
  }

  .gbp {
    color: #36a3f7;
  }

  .eur {
    color: #f4516c;
  }

  .usd {
    color: #34bfa3;
  }

  .show-card {
    text-align: center;
  }

  @media (max-width: 550px) {
    .balance-currency {
      font-size: 5rem;
    }
    .balance-number {
      font-size: 1.5rem;
    }
    .balance-text {
      font-size: 0.75rem;
    }
  }
}
</style>
